(() => {
  const SELECTOR = '[data-product-card-shipping]';
  let showingFreeShipping = false;
  let updateQueued = false;

  const getIstanbulParts = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Istanbul',
      weekday: 'short',
      hour: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());

    return {
      weekday: parts.find((part) => part.type === 'weekday')?.value,
      hour: Number(parts.find((part) => part.type === 'hour')?.value || 0),
    };
  };

  const getShippingText = () => {
    const { weekday, hour } = getIstanbulParts();

    if (weekday === 'Sun') {
      return 'En geç pazartesi kargoda!';
    }

    return hour < 14 ? 'Bugün kargoda!' : 'En geç yarın kargoda!';
  };

  const updateShippingTexts = (root = document) => {
    const text = getShippingText();
    root.querySelectorAll(SELECTOR).forEach((badge) => {
      const deliveryText = badge.querySelector('[data-shipping-text]');

      if (deliveryText && deliveryText.textContent !== text) {
        deliveryText.textContent = text;
      }
    });
  };

  const rotateFreeShippingBadges = () => {
    showingFreeShipping = !showingFreeShipping;

    document.querySelectorAll(`${SELECTOR}[data-free-shipping="true"]`).forEach((badge) => {
      badge.classList.toggle('is-free-shipping', showingFreeShipping);
    });
  };

  const queueUpdate = () => {
    if (updateQueued) return;

    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateShippingTexts();
    });
  };

  const init = () => {
    updateShippingTexts();
    window.setInterval(updateShippingTexts, 60000);
    window.setInterval(rotateFreeShippingBadges, 3000);

    new MutationObserver(queueUpdate).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
